import { useGetCurrentUser } from "@workspace/api-client-react";
import SetupProfile from "@/pages/setup-profile";

export default function ProfileSetupGuard({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useGetCurrentUser();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-muted-foreground font-mono text-sm animate-pulse">Loading...</div>
      </div>
    );
  }

  if (data && !data.isAdmin && data.members.length === 0) {
    return <SetupProfile startOnCreate={data.canCreateSquad} />;
  }

  return <>{children}</>;
}
